import { render, staticRenderFns } from "./accordian.vue?vue&type=template&id=dd2eaf6c&"
import script from "./accordian.vue?vue&type=script&lang=js&"
export * from "./accordian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports